var _ellipse, _ellipse2, _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsersInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.5391,
    cy: 26.9682,
    rx: 13.5391,
    ry: 2.22795,
    fill: "url(#paint0_radial_11321_50334)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.5389,
    cy: 26.9678,
    rx: 5.48418,
    ry: 0.342761,
    fill: "url(#paint1_radial_11321_50334)",
    fillOpacity: 0.7
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 14.5,
    r: 11,
    fill: "#D8D8D8",
    stroke: "#D8D8D8",
    strokeWidth: 3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11321_50334)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7913 18.625V17.7083C15.7913 17.2221 15.5982 16.7558 15.2544 16.412C14.9106 16.0682 14.4442 15.875 13.958 15.875H10.2913C9.80511 15.875 9.3388 16.0682 8.99498 16.412C8.65116 16.7558 8.45801 17.2221 8.45801 17.7083V18.625",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1253 14.0417C13.1378 14.0417 13.9587 13.2209 13.9587 12.2083C13.9587 11.1958 13.1378 10.375 12.1253 10.375C11.1128 10.375 10.292 11.1958 10.292 12.2083C10.292 13.2209 11.1128 14.0417 12.1253 14.0417Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.542 18.626V17.7093C18.5417 17.3031 18.4065 16.9085 18.1576 16.5874C17.9087 16.2664 17.5603 16.0371 17.167 15.9355",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.333 10.4355C15.7274 10.5365 16.0769 10.7659 16.3265 11.0874C16.5761 11.409 16.7116 11.8045 16.7116 12.2116C16.7116 12.6187 16.5761 13.0142 16.3265 13.3357C16.0769 13.6573 15.7274 13.8867 15.333 13.9876",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_11321_50334",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.5391 26.9682) rotate(90) scale(2.22795 13.5391)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A2A2A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_11321_50334",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.5389 26.9678) rotate(90) scale(0.342761 5.48418)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11321_50334"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    fill: "white",
    transform: "translate(8 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersInactive);
export default __webpack_public_path__ + "static/media/users-inactive.225577c47e4f1d72852fdd700eed6331.svg";
export { ForwardRef as ReactComponent };